/*
 * Estados de una sección del tablero: cargando (bloques grises), error (mensaje del servidor y botón
 * Reintentar), vacío ("Sin marcaciones en este rango" con qué probar) o el contenido. Reemplaza el
 * error rojo que mostraba la gráfica anterior cuando no había datos.
 */
import React from "react";

const StateView = ({
    status, message, onRetry, isEmpty, children,
    emptyTitle = 'Sin marcaciones en este rango',
    emptyHint = 'Prueba con otro periodo o quita los filtros de zona, tienda o empleado.',
}) => {
    if (status === 'idle' || status === 'loading') {
        return (
            <div className="mc-skeleton" aria-busy="true">
                <span className="sr-only" role="status">Cargando marcaciones…</span>
                <div className="mc-skeleton__row"/>
                <div className="mc-skeleton__row"/>
                <div className="mc-skeleton__row"/>
            </div>
        );
    }
    if (status === 'error') {
        return (
            <div className="mc-state mc-state--error" role="alert">
                <i className="bx bx-error-circle" aria-hidden="true"/>
                <p className="mc-state__title">No se pudo cargar la información</p>
                <p className="mc-state__text">{message}</p>
                {onRetry && <button type="button" className="btn btn-outline-primary btn-sm" onClick={onRetry}>Reintentar</button>}
            </div>
        );
    }
    if (isEmpty) {
        return (
            <div className="mc-state">
                <i className="bx bx-calendar-x" aria-hidden="true"/>
                <p className="mc-state__title">{emptyTitle}</p>
                <p className="mc-state__text">{emptyHint}</p>
            </div>
        );
    }
    return children;
};

export default StateView;
